import './style.scss';

import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import Modal from './tools/modal';
import MemorialSearch from './tools/memorial-search.js';

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
	/** All pages */
	common,
	/** Home page */
	home,
});

/**
 * Initialize Modal System
 */
const modalSystem = new Modal();

// Export for global access if needed
window.OutpressModal = modalSystem;


/**
 * Memorial Search
 */
const MemorialGrid = document.querySelector('[data-oitm-memorial-grid]');
if (MemorialGrid) new MemorialSearch(MemorialGrid);

/** Load Events */
document.addEventListener('DOMContentLoaded', () => routes.loadEvents());
